export const AuthEventTypes = {
  ResetPassword: "ResetPassword",
  Login: "Login",
  TwoFactor: "TwoFactor",
  TwoFactorEnable: "TwoFactorEnable",
  TwoFactorDisable: "TwoFactorDisable",
  EmailTwoFactorEnable: "EmailTwoFactorEnable",
  EmailTwoFactorDisable: "EmailTwoFactorDisable",
  TenantEmailTwoFactorEnable: "TenantEmailTwoFactorEnable",
  TenantEmailTwoFactorDisable: "TenantEmailTwoFactorDisable",
  PaperVerification: "PaperVerification",
  ParentViewEmail: "ParentViewEmail",
  EmailVerification: "EmailVerification",
  PhoneVerification: "PhoneVerification",
  AuthenitcatorVerify: "AuthenitcatorVerify",
  AddUsdtWallet: "AddUsdtWallet",
  UpdateUsdtWallet: "UpdateUsdtWallet",
  CreatePaymentInfo: "CreatePaymentInfo",
  UpdatePaymentInfo: "UpdatePaymentInfo",
  CreateWithdrawal: "CreateWithdrawal",
  CreateTenantCryptoWallet: "CreateTenantCryptoWallet",
  UpdateTenantCryptoWalletStatus: "UpdateTenantCryptoWalletStatus",
  SticPayWithdraw: "SticPayWithdraw",
} as const;

export type AuthEventType = typeof AuthEventTypes[keyof typeof AuthEventTypes];
